// Template actions
export const addNewTemplate = (templateType, options, activeApp) => ({
  type: "ADD_NEW_TEMPLATE",
  templateType,
  options,
  activeApp,
});

export const updateTemplate = (template) => ({
  type: "UPDATE_TEMPLATE",
  template,
});
